import axios from 'axios';

const API_BASE_URL = 'https://purity-api.dit.sa';
// const API_BASE_URL = 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
});

// Add token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// News API
export const newsApi = {
  getAll: () => api.get('/news'),
  getById: (id: string) => api.get(`/news/${id}`),
  create: (data: any) => api.post('/news', data),
  update: (id: string, data: any) => api.put(`/news/${id}`, data),
  delete: (id: string) => api.delete(`/news/${id}`),
};

// Products API
export const productsApi = {
  getAll: (lang = 'en') => api.get(`/products?lang=${lang}`),
  getById: (id: string, lang = 'en') => api.get(`/products/${id}?lang=${lang}`),
  create: (data: any) => api.post('/products', data),
  update: (id: string, data: any) => api.put(`/products/${id}`, data),
  delete: (id: string) => api.delete(`/products/${id}`),
};

// // Services API
// export const servicesApi = {
//   getAll: () => api.get('/services'),
//   getById: (id: string) => api.get(`/services/${id}`),
//   create: (data: any) => api.post('/services', data),
//   update: (id: string, data: any) => api.put(`/services/${id}`, data),
//   delete: (id: string) => api.delete(`/services/${id}`),
// };
// Services API - matches backend ServiceController
export const servicesApi = {
  // Get all services with optional locale support
  getAll: (locale?: string) => 
    api.get('/services', {
      headers: locale ? { 'X-Locale': locale } : {}
    }),
  
  // Get service by ID with optional raw parameter for editing
  getById: (id: string, raw: boolean = false) => 
    api.get(`/services/${id}${raw ? '?raw=true' : ''}`),
  
  // Create service with FormData (supports file uploads)
  create: (data: FormData) =>
    api.post('/services', data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  
  // Update service with FormData (supports file uploads)
  update: (id: string, data: FormData) =>
    api.put(`/services/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  
  // Delete service
  delete: (id: string) => api.delete(`/services/${id}`),
};


// News Cards API
export const newsCardsApi = {
  getAll: () => api.get('/news-cards'),
  getById: (id: string) => api.get(`/news-cards/${id}`),
  create: (data: any) => api.post('/news-cards', data),
  update: (id: string, data: any) => api.put(`/news-cards/${id}`, data),
  delete: (id: string) => api.delete(`/news-cards/${id}`),
};

// Service Cards API
export const serviceCardsApi = {
  getAll: () => api.get('/service-cards'),
  getById: (id: string) => api.get(`/service-cards/${id}`),
  create: (data: any) => api.post('/service-cards', data),
  update: (id: string, data: any) => api.put(`/service-cards/${id}`, data),
  delete: (id: string) => api.delete(`/service-cards/${id}`),
};

// Dashboard API
export const dashboardApi = {
  getStats: () => api.get('/dashboard/stats'),
  getRecentActivity: () => api.get('/dashboard/recent-activity'),
};

// Authentication API
export const authApi = {
  login: (credentials: { email: string; password: string }) => 
    api.post('/auth/login', credentials),
  logout: () => api.post('/auth/logout'),
  verifyToken: () => api.get('/auth/me'),
  refreshToken: () => api.post('/auth/refresh'),
};

// Image Upload API
export const uploadApi = {
  uploadImage: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/upload-image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export default api;
